import React from 'react'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@popperjs/core/dist/umd/popper.min.js'
import GlobalProvider from './src/Context/GlobalContext/Provider'

export const wrapRootElement = ({ element }) => (
  <GlobalProvider>{element}</GlobalProvider>
)
